import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { ICellPhoneLookupResult } from './types';

interface IMarkWrongNumberVariables {
	contactId: string;
	phoneNumber: string;
}

export const useMarkWrongNumberMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Error) => void;
	onSuccess?: (data: ICellPhoneLookupResult, variables: IMarkWrongNumberVariables) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ contactId, phoneNumber }: IMarkWrongNumberVariables) => {
			return userSession.webServiceHelper.callAsync<ICellPhoneLookupResult>(
				`aida/cellphonelookup/${contactId}/wrongNumber`,
				'POST',
				{ phoneNumber }
			);
		},
		onError,
		onSuccess,
	});
};
